export default "__VITE_ASSET__2eb79f11__"